import DateFnsUtils from "@date-io/date-fns"
import {
  Box,
  MenuItem,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core"
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers"
import { Field, Form, Formik } from "formik"
import PropTypes from "prop-types"
import { useRef, useState } from "react"
import { useEffect } from "react"
import InputMask from "react-input-mask"
import usStatesList from "utils/UsStateList"
import * as Yup from "yup"

import useStyles from "./styles"

const Position = ({
  position,
  setPositionsArray,
  positionsArray,
  positions,
  boardTerm,
}) => {
  const formRef = useRef()
  const classes = useStyles()
  const theme = useTheme()
  const mobile = useMediaQuery(theme.breakpoints.down("xs"))

  /* eslint-disable */
  /* eslint-disable */

  // this is injected into the schema to handle if
  // a boardterm is other,require the member term length field
  // then if member term length field is 1-6 years, require the expiration date.
  const memberTermSchema =
    boardTerm?.toLowerCase() === "other"
      ? // if a boardterm is other,require the member term length field;
        // then if member term length field is 1-6 years, require the expirationdate.
        {
          member_term_length: Yup.string()
            .nullable(true)
            .when("currently_vacant", {
              is: false,
              then: Yup.string().required("Required"),
            }),
          term_expiration: Yup.date()
            .nullable(true)
            .when("currently_vacant", {
              is: false,
              then: Yup.date()
                .nullable(true)
                .when("member_term_length", {
                  is: (value) => value?.includes("year"),
                  then: Yup.date().nullable(true).required("Required"),
                }),
            }),
        }
      : // if board term is 1-6 year, makes member term length not req'd
      // & does require a term expiration
      boardTerm?.includes("year")
      ? {
          member_term_length: Yup.string().nullable(true),
          term_expiration: Yup.date()
            .nullable(true)
            .when("currently_vacant", {
              is: false,
              then: Yup.date().nullable(true).required("Required"),
            }),
        }
      : {
          // no requirement for either boardTerm of Cotermionus or No Limit
          member_term_length: Yup.string().nullable(true),
          term_expiration: Yup.date().nullable(true),
        }

  /* eslint-enable */

  const phoneRegex = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/
  const schema = Yup.object().shape({
    id: Yup.string(),
    position: Yup.string(),
    member: Yup.object().shape({
      ...memberTermSchema,
      first_name: Yup.string().when("currently_vacant", {
        is: false,
        then: Yup.string().required("Required"),
      }),
      last_name: Yup.string().when("currently_vacant", {
        is: false,
        then: Yup.string().required("Required"),
      }),
      terms_served: Yup.string()
        .nullable(true)
        .when("currently_vacant", {
          is: false,
          then: Yup.string().nullable(true).required("Required"),
        }),
      email: Yup.string().when("currently_vacant", {
        is: false,
        then: Yup.string()
          .email("Please enter a valid email")
          .required(`Required`),
      }),
      race: Yup.string(),
      dob: Yup.date().nullable(true),
      currently_vacant: Yup.bool(),
      address: Yup.string().notRequired(),
      city: Yup.string().notRequired(),
      zip_code: Yup.string().notRequired(),
      state: Yup.string().notRequired(),
      phone: Yup.string()
        .matches(phoneRegex, "Phone number not valid")
        .min(14, "Phone number is not valid")
        .max(14, "Phone number is not valid")
        .notRequired(),
    }),
  })

  const onSubmit = (values, actions) => {
    // console.log(values)
  }

  useEffect(() => {
    // on page load, handles addition of ref object to each member
    if (
      formRef &&
      formRef.current &&
      !positionsArray.find(
        (x, ii) => x.id === position.id && x.ref && x.ref.current
      )
    ) {
      setPositionsArray((oldState) =>
        oldState.map((x, ii) =>
          x.id === position.id
            ? { ...x, ref: formRef, values: formRef.current.values }
            : x
        )
      )
    }
  }, [formRef, formRef.current])

  //refresh data if you come from step 5
  useEffect(() => {
    if (positions?.find((x) => x.id === position.id)) {
      formRef.current.setFieldValue(
        "position",
        positions.find((x) => x.id === position.id).position
      )
      formRef.current.setFieldValue(
        "member.first_name",
        positions.find((x) => x.id === position.id).member.first_name
      )
      formRef.current.setFieldValue(
        "member.last_name",
        positions.find((x) => x.id === position.id).member.last_name
      )
      formRef.current.setFieldValue(
        "member.member_term_length",
        positions.find((x) => x.id === position.id).member.member_term_length
      )
      formRef.current.setFieldValue(
        "member.term_expiration",
        positions.find((x) => x.id === position.id).member.term_expiration
      )
      formRef.current.setFieldValue(
        "member.terms_served",
        positions.find((x) => x.id === position.id).member.terms_served
      )
      formRef.current.setFieldValue(
        "member.currently_vacant",
        positions.find((x) => x.id === position.id).member.currently_vacant
      )
      formRef.current.setFieldValue(
        "member.email",
        positions.find((x) => x.id === position.id).member.email
      )
      formRef.current.setFieldValue(
        "member.race",
        positions.find((x) => x.id === position.id).member.race
      )
      formRef.current.setFieldValue(
        "member.gender",
        positions.find((x) => x.id === position.id).member.gender
      )
      formRef.current.setFieldValue(
        "member.dob",
        positions.find((x) => x.id === position.id).member.dob
      )
    }
    setTimeout(() => {
      formRef?.current?.setErrors({})
    }, [])
  }, [])

  return (
    <Formik
      initialValues={{
        id: position?.id,
        position: "",
        member: {
          first_name: "",
          last_name: "",
          member_term_length: "",
          term_expiration: null,
          terms_served: null,
          email: "",
          race: "",
          gender: "",
          dob: null,
          address: "",
          city: "",
          zip_code: "",
          state: "",
          phone: "",
          currently_vacant: true,
        },
      }}
      onSubmit={onSubmit}
      validationSchema={schema}
      innerRef={formRef}
    >
      {({
        handleChange,
        values,
        errors,
        touched,
        handleBlur,
        isSubmitting,
        handleSubmit,
        setFieldValue,
        initialValues,
        setErrors,
        resetForm,
      }) => {
        return (
          <Form onSubmit={handleSubmit}>
            <Box className={classes.container}>
              <Box className={classes.topContainer}>
                <Box>
                  <Box className={classes.rowWrapper}>
                    <TextField
                      type="text"
                      label="Role/District"
                      variant="outlined"
                      onChange={(e) => {
                        setFieldValue("position", e.target.value)
                      }}
                      onBlur={handleBlur}
                      helperText={touched.position && errors.position}
                      value={values.position}
                      error={Boolean(touched.position && errors.position)}
                      FormHelperTextProps={{
                        className: classes.formHelperText,
                      }}
                      className={classes.textfieldFirstRow}
                    />
                    <TextField
                      type="text"
                      label={
                        values?.member?.currently_vacant
                          ? "First Name"
                          : "First Name*"
                      }
                      variant="outlined"
                      onChange={(e) => {
                        setFieldValue("member.first_name", e.target.value)
                        if (e?.target?.value !== "") {
                          setFieldValue("member.currently_vacant", false)
                        }
                      }}
                      onBlur={handleBlur}
                      helperText={
                        touched?.member?.first_name &&
                        errors?.member?.first_name
                      }
                      value={values?.member?.first_name}
                      error={Boolean(
                        touched?.member?.first_name &&
                          errors?.member?.first_name
                      )}
                      FormHelperTextProps={{
                        className: classes.formHelperText,
                      }}
                      className={classes.textfieldFirstRow}
                    />
                    <TextField
                      type="text"
                      label={
                        values?.member?.currently_vacant
                          ? "Last Name"
                          : "Last Name*"
                      }
                      variant="outlined"
                      onChange={(e) => {
                        setFieldValue("member.last_name", e.target.value)
                        if (e?.target?.value !== "") {
                          setFieldValue("member.currently_vacant", false)
                        }
                      }}
                      onBlur={handleBlur}
                      helperText={
                        touched?.member?.last_name && errors?.member?.last_name
                      }
                      value={values?.member?.last_name}
                      error={Boolean(
                        touched?.member?.last_name && errors?.member?.last_name
                      )}
                      className={classes.textfieldFirstRow}
                      FormHelperTextProps={{
                        className: classes.formHelperText,
                      }}
                    />
                  </Box>
                  <Box className={classes.rowWrapper} flexWrap="wrap">
                    <TextField
                      select
                      id="member_term_length"
                      name="member_term_length"
                      label="Member Term Length"
                      value={values?.member?.member_term_length}
                      onChange={(e) => {
                        setFieldValue(
                          "member.member_term_length",
                          e.target.value
                        )
                      }}
                      onBlur={handleBlur}
                      variant="outlined"
                      helperText={
                        touched?.member?.member_term_length &&
                        errors?.member?.member_term_length
                      }
                      error={Boolean(
                        touched?.member?.member_term_length &&
                          errors?.member?.member_term_length
                      )}
                      className={classes.textfieldSecondRow}
                      style={
                        mobile
                          ? { marginBottom: "10px", flexGrow: 1 }
                          : { flexGrow: 1 }
                      }
                      FormHelperTextProps={{
                        className: classes.formHelperText,
                      }}
                      disabled={boardTerm?.toLowerCase() !== "other"} // only enabled if other is the selected Board.term
                    >
                      <MenuItem value={"1 year"}>1 year</MenuItem>
                      <MenuItem value={"2 years"}>2 years</MenuItem>
                      <MenuItem value={"3 years"}>3 years</MenuItem>
                      <MenuItem value={"4 years"}>4 years</MenuItem>
                      <MenuItem value={"5 years"}>5 years</MenuItem>
                      <MenuItem value={"6 years"}>6 years</MenuItem>
                      <MenuItem value={"coterminous"}>Coterminous</MenuItem>
                      <MenuItem value={"no term limit"}>No term limit</MenuItem>
                    </TextField>
                    <Box
                      style={{
                        marginRight: "10px",
                        position: "relative",
                      }}
                      className={classes.boxRoot}
                    >
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                          disableToolbar
                          inputVariant="outlined"
                          format="MM/dd/yyyy"
                          className={classes.textfieldSecondRow}
                          classes={
                            errors?.member?.term_expiration &&
                            touched?.member?.term_expiration
                              ? { root: classes.termDatePicker }
                              : null
                          }
                          style={{ width: "100%" }}
                          id="date-picker-member-exp"
                          label="Term expiration"
                          openTo="year"
                          views={["year", "month", "date"]}
                          value={values?.member?.term_expiration}
                          onChange={(e) => {
                            setFieldValue("member.term_expiration", e)
                            if (e) {
                              setFieldValue("member.currently_vacant", false)
                            }
                          }}
                          helperText={
                            touched?.member?.term_expiration &&
                            errors?.member?.term_expiration
                          }
                          error={Boolean(
                            touched?.member?.term_expiration &&
                              errors?.member?.term_expiration
                          )}
                          KeyboardButtonProps={{
                            "aria-label": "change date",
                          }}
                        />
                      </MuiPickersUtilsProvider>
                    </Box>
                    <TextField
                      type="number"
                      label="Terms Served"
                      variant="outlined"
                      onChange={(e) => {
                        setFieldValue("member.terms_served", e.target.value)
                        if (e?.target?.value !== "") {
                          setFieldValue("member.currently_vacant", false)
                        }
                      }}
                      onBlur={handleBlur}
                      helperText={
                        touched?.member?.terms_served &&
                        errors?.member?.terms_served
                      }
                      value={values?.member?.terms_served}
                      error={Boolean(
                        touched?.member?.terms_served &&
                          errors?.member?.terms_served
                      )}
                      InputProps={{
                        classes: {
                          root: classes.inputBackgroundColor,
                        },
                      }}
                      className={classes.textfieldSecondRow}
                      FormHelperTextProps={{
                        className: classes.formHelperText,
                      }}
                    />
                  </Box>

                  <Box
                    display="flex"
                    alignItems="center"
                    className={classes.textfieldSecondRow}
                    style={boardTerm === "other" ? { marginTop: "20px" } : null}
                  >
                    <Field
                      onChange={(e) => {
                        if (e?.target?.value === "false") {
                          resetForm({
                            values: {
                              id: values?.position_id,
                              position: values?.position,
                              member: {
                                first_name: "",
                                last_name: "",
                                member_term_length: "",
                                term_expiration: null,
                                terms_served: null,
                                email: "",
                                race: "",
                                gender: "",
                                dob: null,
                              },
                            },
                          })
                          setErrors({})
                        }

                        handleChange(e)
                      }}
                      type="checkbox"
                      name={"member.currently_vacant"}
                    />
                    <Typography>Currently Vacant</Typography>
                  </Box>
                </Box>
              </Box>
              <Typography color="primary" style={{ marginLeft: "5px" }}>
                Recommended
              </Typography>
              <Box className={classes.bottomContainer}>
                <Box
                  style={mobile ? { marginBottom: "10px" } : { width: "15%" }}
                >
                  <Typography color="primary">
                    For internal purposes only
                  </Typography>
                </Box>
                <Box
                  style={mobile ? null : { width: "85%" }}
                  display="flex"
                  flexWrap="wrap"
                >
                  <TextField
                    type="text"
                    label="Email"
                    variant="outlined"
                    onChange={(e) => {
                      setFieldValue("member.email", e.target.value)
                      if (e?.target?.value !== "") {
                        setFieldValue("member.currently_vacant", false)
                      }
                    }}
                    onBlur={handleBlur}
                    helperText={touched?.member?.email && errors?.member?.email}
                    value={values?.member?.email}
                    error={Boolean(
                      touched?.member?.email && errors?.member?.email
                    )}
                    style={{ marginRight: "5px" }}
                    InputProps={{
                      classes: {
                        root: classes.inputBackgroundColor,
                      },
                    }}
                    className={classes.textfieldThirddRow}
                  />
                  <TextField
                    select
                    label="Race"
                    value={values?.member?.race}
                    onChange={(e) => {
                      setFieldValue("member.race", e.target.value)
                      if (e?.target?.value !== "") {
                        setFieldValue("member.currently_vacant", false)
                      }
                    }}
                    variant="outlined"
                    fullWidth
                    style={{ marginRight: "5px" }}
                    helperText={touched?.member?.race && errors?.member?.race}
                    error={Boolean(
                      touched?.member?.race && errors?.member?.race
                    )}
                    InputProps={{
                      classes: {
                        root: classes.inputBackgroundColor,
                      },
                    }}
                    className={classes.textfieldThirddRow}
                  >
                    <MenuItem value={"asian/pacific islander"}>
                      Asian/Pacific Islander
                    </MenuItem>
                    <MenuItem value={"black/african american"}>
                      Black/African American
                    </MenuItem>
                    <MenuItem value={"hispanic/latin"}>Hispanic/Latin</MenuItem>
                    <MenuItem value={"native american"}>
                      Native American
                    </MenuItem>
                    <MenuItem value={"white"}>White</MenuItem>
                    <MenuItem value={"two or more races"}>
                      Two or more races
                    </MenuItem>
                    <MenuItem value={"other"}>Other</MenuItem>
                    <MenuItem value={"prefer not to say"}>
                      Prefer not to say
                    </MenuItem>
                  </TextField>
                  <TextField
                    select
                    label="Gender"
                    value={values?.member?.gender}
                    onChange={(e) => {
                      setFieldValue("member.gender", e.target.value)
                      if (e?.target?.value !== "") {
                        setFieldValue("member.currently_vacant", false)
                      }
                    }}
                    variant="outlined"
                    fullWidth
                    style={{ marginRight: "5px" }}
                    helperText={
                      touched?.member?.gender && errors?.member?.gender
                    }
                    error={Boolean(
                      touched?.member?.gender && errors?.member?.gender
                    )}
                    InputProps={{
                      classes: {
                        root: classes.inputBackgroundColor,
                      },
                    }}
                    className={classes.textfieldThirddRow}
                  >
                    <MenuItem value={"male"}>Male</MenuItem>
                    <MenuItem value={"female"}>Female</MenuItem>
                    <MenuItem value={"non binary"}>Non binary</MenuItem>
                    <MenuItem value={"prefer not to say"}>
                      Prefer not to say
                    </MenuItem>
                  </TextField>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      disableToolbar
                      inputVariant="outlined"
                      format="MM/dd/yyyy"
                      openTo="year"
                      views={["year", "month", "date"]}
                      id="date-picker-member-dob"
                      label="DOB"
                      value={values?.member?.dob}
                      classes={{ root: classes.dobDatePicker }}
                      onChange={(e) => {
                        setFieldValue("member.dob", e)
                        if (e) {
                          setFieldValue("member.currently_vacant", false)
                        }
                      }}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      className={classes.textfieldThirddRow}
                    />
                  </MuiPickersUtilsProvider>
                  <TextField
                    label="Address"
                    variant="outlined"
                    onChange={(e) => {
                      setFieldValue("member.address", e.target.value)
                    }}
                    onBlur={handleBlur}
                    helperText={
                      touched?.member?.address && errors?.member?.address
                    }
                    value={values?.member?.address}
                    error={Boolean(
                      touched?.member?.address && errors?.member?.address
                    )}
                    InputProps={{
                      classes: {
                        root: classes.inputBackgroundColor,
                      },
                    }}
                    className={classes.textfieldSecondRow}
                    FormHelperTextProps={{
                      className: classes.formHelperText,
                    }}
                    style={{ marginTop: "5px" }}
                  />
                  <TextField
                    label="City"
                    variant="outlined"
                    onChange={(e) => {
                      setFieldValue("member.city", e.target.value)
                    }}
                    onBlur={handleBlur}
                    helperText={touched?.member?.city && errors?.member?.city}
                    value={values?.member?.city}
                    error={Boolean(
                      touched?.member?.city && errors?.member?.city
                    )}
                    InputProps={{
                      classes: {
                        root: classes.inputBackgroundColor,
                      },
                    }}
                    className={classes.textfieldSecondRow}
                    FormHelperTextProps={{
                      className: classes.formHelperText,
                    }}
                    style={{ marginTop: "5px" }}
                  />
                  <TextField
                    label="Zip code"
                    variant="outlined"
                    onChange={(e) => {
                      setFieldValue("member.zip_code", e.target.value)
                    }}
                    onBlur={handleBlur}
                    helperText={
                      touched?.member?.zip_code && errors?.member?.zip_code
                    }
                    value={values?.member?.zip_code}
                    error={Boolean(
                      touched?.member?.zip_code && errors?.member?.zip_code
                    )}
                    InputProps={{
                      classes: {
                        root: classes.inputBackgroundColor,
                      },
                    }}
                    className={classes.textfieldSecondRow}
                    FormHelperTextProps={{
                      className: classes.formHelperText,
                    }}
                    style={{ marginTop: "5px" }}
                  />
                  <TextField
                    select
                    label="ST"
                    value={values?.member?.state}
                    onChange={(e) => {
                      setFieldValue("member.state", e.target.value)
                    }}
                    variant="outlined"
                    fullWidth
                    style={{ marginRight: "5px", marginTop: "5px" }}
                    helperText={touched?.member?.state && errors?.member?.state}
                    error={Boolean(
                      touched?.member?.state && errors?.member?.state
                    )}
                    InputProps={{
                      classes: {
                        root: classes.inputBackgroundColor,
                      },
                    }}
                    className={classes.textfieldThirddRow}
                  >
                    {usStatesList.map((state, idx) => (
                      <MenuItem value={state} key={idx}>
                        {state}
                      </MenuItem>
                    ))}
                  </TextField>
                  <InputMask
                    id="phone-mask"
                    mask="(999) 999-9999"
                    maskChar="_"
                    value={values.phone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  >
                    {() => (
                      <TextField
                        type="text"
                        name="phone"
                        label="Phone"
                        data-cy="member-phone"
                        id="phone"
                        helperText={touched.phone && errors.phone}
                        style={{
                          backgroundColor: "#F8F8F8",
                          marginBottom: "25px",
                          marginTop: "5px",
                          marginRight: "10px",
                        }}
                        variant="outlined"
                        width={"25%"}
                        InputProps={{
                          classes: {
                            root: classes.inputBackgroundColor,
                          },
                        }}
                        FormHelperTextProps={{
                          className: classes.formHelperText,
                        }}
                        error={Boolean(touched.phone && errors.phone)}
                      />
                    )}
                  </InputMask>
                </Box>
              </Box>
            </Box>
          </Form>
        )
      }}
    </Formik>
  )
}
Position.propTypes = {
  key: PropTypes.string,
  position: PropTypes.object,
  setPositionsArray: PropTypes.func,
  positionsArray: PropTypes.array,
  positions: PropTypes.array,
  boardTerm: PropTypes.string,
}

export default Position
